import {
  Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, Select, TextField,
  Typography
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setAlert } from 'src/store/actions/alertActions';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import axios from 'src/utils/axios';

function MaterialDebitVerification({ open, setOpen, setAlert }) {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [FisNo, setFisNo] = useState(0);


  useEffect(() => {
    setLoading(true);
    let job = loadBaslandiJob()[0];
    setFisNo(job.FisNo);
    let materials = job.MALZEMELER.map(m => {
      return {
        materialId: m.MALZEME_KODU,
        count: parseInt(m.ADET)
      }
    });
    const user = getUser();
    const body = {
      serviceShopId: user.ServiceShopId,
      technicianId: user.TechnicianId,
      materials: materials
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post(`/DebitDetails`, body, config)
      .then(res => {
        if (typeof res.data === 'object') { // success
          setData(res.data);
        } else { // error
          setAlert(res.data);
          setData([]);
        }
        setLoading(false);
      })
    // eslint-disable-next-line
  }, []);


  const changeData = (obj, column, newValue, shouldParse = false) => {
    let oldData = [...data];
    oldData = oldData.filter(o => o.materialId !== obj.materialId);
    obj[column] = shouldParse ? parseInt(newValue) : newValue;
    setData([...oldData, obj]);
  }


  const verifyInputs = () => {
    if (data.filter(d => d.reason === 0).length > 0) {
      setAlert('Tüm Malzemeleriniz için seçim yapmanız gerekmektedir!..');
      return false;
    }
    if (data.filter(d => d.reason === 1 && d.selectedTechnicianId === 0).length > 0) {
      setAlert('Teknisyen seçiniz!..');
      return false;
    }
    if (data.filter(d => d.reason === 2 && d.equivalentMaterialId === 0).length > 0) {
      setAlert('Muadil malzeme seçiniz!..');
      return false;
    }

    if (data.filter(d => d.reason === 3 && d.otherDesc?.length === 0).length > 0) {
      setAlert('Diğer seçeneği için açıklama yazınız!...');
      return false;
    }

    return true;
  }


  const handleSetDebitDetails = () => {
    const verify = verifyInputs();
    if (!verify)
      return;
    const user = getUser();
    let body = data.map(d => {
      return {
        serviceShopId: user.ServiceShopId,
        technicianId: user.TechnicianId,
        materialId: d.materialId,
        materialCode: d.materialCode,
        count: d.count,
        reason: d.reason,
        selectedTechnicianId: d.selectedTechnicianId,
        equivalentMaterialId: d.equivalentMaterialId,
        otherDesc: d.otherDesc,
        ServicePaperNr: FisNo
      }
    });
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };


    setLoading(true);
    axios.post(`/SetDebitDetails`, body, config)
      .then(res => {
        res.data.forEach(item => {
          if (parseInt(item.ErrorCode) !== 0) {
            setAlert(item.ErrorDescription);
            setLoading(false);
            return;
          }
        });
        setLoading(false);
        setOpen(false);
      })
  }



  return (
    <Dialog
      open={open}
      fullScreen
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          setOpen(false); // Sadece arka plana tıklanmadığı (mesaj veya butonla kapatıldığı) durumlarda kapat
        }
      }}
    >
      <DialogTitle color="primary">{FisNo + " Numaralı fişinize ait zimmetinizde olmayan malzemeler bulunuyor!..."}</DialogTitle>
      <DialogContent>
        {loading && <CircularProgress
          status={'loading'}
          style={{ marginLeft: '50%' }}
        />}
        {data.sort((a, b) => a.materialId > b.materialId ? 1 : -1).map(d =>
          <Card>
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <Typography color="textSecondary">
                {" Malzeme Stok No"}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {' ' + d.materialCode}
              </Typography>
              <Typography color="textSecondary">
                {" Malzeme"}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {' ' + d?.materialDesc}
              </Typography>
            </FormControl>
            <CardContent>
              <FormControl variant="outlined" style={{ width: '100%' }}>
                <Select
                  native
                  value={d.reason}

                  onChange={(e) => {
                    changeData(d, 'reason', e.target.value, true);
                    e.target.value === "3" && setAlert("Servisinizle İletişim kurup, malzemenin size zimmetlenmesini sağlayın")
                  }}
                  fullWidth
                >
                  <option value={0}>Seçim Yapınız!...</option>
                  <option value={1}>Diğer teknisyenden aldım</option>
                  <option value={2}>Muadil kullandım</option>
                  <option value={3}>Zimmetimde yok</option>
                </Select>
              </FormControl>
              <br />
              <br />
              {
                d.reason === 1 &&
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <Select
                    native
                    value={d.selectedTechnicianId}
                    onChange={(e) => changeData(d, 'selectedTechnicianId', e.target.value, true)}
                    label="Age"
                    fullWidth
                  >
                    <option value={0}>Teknisyen Seçiniz...</option>
                    {d.technician.map(t => <option value={t.technicianId}>{t.technicianDesc}</option>)}
                  </Select>
                </FormControl>
              }
              {
                d.reason === 2 &&
                <TextField
                  label='Malzeme Stok No'
                  fullWidth
                  value={d.equivalentMaterialId}
                  onChange={(e) => changeData(d, 'equivalentMaterialId', e.target.value, false)}
                  variant="outlined" />
                // <MalzemeSearch
                //   setMalzeme={(param) => changeData(d, 'equivalentMaterialId', param.MALZEME_STOK_NO, true)}
                //   value={{
                //     MALZEME_STOK_NO: d.equivalentMaterialId,
                //     ACIKLAMA: ""
                //   } || ''}
                //   searchParam={SearchParamDetail}
                // />
              }
              {
                d.reason === 3 &&
                'Servisinizle İletişim kurup, malzemenin size zimmetlenmesini sağlayın'
                // <TextField
                //   label='Açıklama yazınız'
                //   fullWidth
                //   value={d.otherDesc}
                //   onChange={(e) => changeData(d, 'otherDesc', e.target.value, false)}
                //   variant="outlined" />
              }
            </CardContent>
          </Card>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleSetDebitDetails()} color="primary">
          Onayla
        </Button>
        <Button onClick={() => setOpen(false)} color="primary">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default connect(
  state => ({
    materialReducer: state.materialReducer,
  }),
  { setAlert }
)(MaterialDebitVerification);
